module.exports = __webpack_public_path__ + "static/media/Birthday Party Girl.99ad5490.jpg";